let timelineElements = [
  {
    id: 1,
    title: "Software Engineer - I",
    location: "Paycraft Solutions, Mumbai, Maharashtra",
    description: [
      "Engineered a Topup feature for TOM/Mobile App channels, facilitating secure wallet top-ups for individual customers based on wallet identifiers as part of Gujarat Metro Project.",
      "Developed and implemented an advanced queuing mechanism for transit wallets, ensuring accurate allocation of amount loaded into the queue while maintaining support for multiple payment modes. This enhancement improved transaction processing efficiency by 40%.",
      "Designed and built a microservice that consumes Airtel Payments Bank API, performing encryption-decryption and response handling on the APIs. This microservice is integrated into Paycraft’s internal card management system, streamlining the process of card management and enhancing security measures.",
    ],
    date: "January 2024 - Present",
    icon: "work",
  },
  {
    id: 2,
    title: "Technical Assessor",
    location: "Masai, Bengaluru, Karnataka, India",
    description: [
      "Conducted mock interviews to evaluate and prepare new joiners for technical interviews, providing valuable feedback and guidance.",
      "Assessed technical assignments submitted by new joiners, analyzing their skills and providing constructive feedback for improvement.",
    ],
    date: "October 2023 - March 2024 (6 months)",
    icon: "work",
  },
  {
    id: 3,
    title: "Software Engineer",
    location: "RadicalX",
    description: [
      "Embraced cutting-edge technologies like OpenAI, Vertex AI, and TensorFlow to enhance ReX, our AI Coach.",
    ],
    date: "November 2023 - December 2023 (2 months)",
    icon: "work",
  },
  // If you want to add more elements, uncomment and modify as needed
  // {
  //   id: 4,
  //   title: "Full Stack Web Development Student",
  //   location: "Masai School, Bangalore, Karnataka",
  //   description: [
  //     "Completed a comprehensive full stack web development program, gaining proficiency in JavaScript, ReactJS, NodeJS, Django, and other web technologies."
  //   ],
  //
  //   date: "October 2022 - November 2023",
  //   icon: "school",
  // },
  // {
  //   id: 5,
  //   title: "Bachelor of Computer Applications Student",
  //   location: "Christ College, Pune, Maharashtra",
  //   description: [
  //     "Studied core computer science subjects and developed skills in Java, Python, HTML, CSS, and JavaScript.",
  //     "Engaged in various projects and internships to gain practical experience."
  //   ],
  //   buttonText: "View Certificate",
  //   date: "June 2018 - July 2021",
  //   icon: "school",
  // },
];

export default timelineElements;
